var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandpremium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0.75H2.25C1.85218 0.75 1.47064 0.908035 1.18934 1.18934C0.908035 1.47064 0.75 1.85218 0.75 2.25V15.75C0.75 16.1478 0.908035 16.5294 1.18934 16.8107C1.47064 17.092 1.85218 17.25 2.25 17.25H15.75C16.1478 17.25 16.5294 17.092 16.8107 16.8107C17.092 16.5294 17.25 16.1478 17.25 15.75V2.25C17.25 1.85218 17.092 1.47064 16.8107 1.18934C16.5294 0.908035 16.1478 0.75 15.75 0.75ZM9.75 8.25H15.75V9.75H9.75V8.25ZM9.75 6.75V5.25H15.75V6.75H9.75ZM9.75 11.25H15.75V12.75H9.75V11.25ZM15.75 3.75H9.75V2.25H15.75V3.75ZM2.25 2.25H8.25V15.75H2.25V2.25ZM15.75 15.75H9.75V14.25H15.75V15.75Z",
    fill: "#497849"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandpremium);
export default __webpack_public_path__ + "static/media/land premium.94c48107241eee62789cae485bdfdbf9.svg";
export { ForwardRef as ReactComponent };